import {Component} from '@angular/core';
import {ModelloDispositivoApiDescriptor, ScortaMaterialeApiDescriptor, TipoMovimentazione} from "../../../../models/magazzino.model";
import {MessageService} from "primeng/api";
import {DialogService, DynamicDialogConfig, DynamicDialogRef} from "primeng/dynamicdialog";
import {CompoMovimentazione} from "../stato-movimentazioni.component";
import {dateAsDDMMYYYY, dateAsYYYYMMDD, dateFromYYYYMMDDsep, deserializeStringEnum} from "../../../../lib/support";
import {InconsistencyReportDialogComponent} from "../inconsistency-report-dialog/inconsistency-report-dialog.component";

@Component({
  selector: 'app-movimentazione-transfer-dialog',
  templateUrl: './movimentazione-transfer-dialog.component.html',
  styleUrls: ['./movimentazione-transfer-dialog.component.scss']
})
export class MovimentazioneTransferDialogComponent {

	protected readonly TipoMovimentazione = TipoMovimentazione;

	
	hasValidForm: boolean;

	movref: CompoMovimentazione;
	movtype: TipoMovimentazione;

	action_date: Date;
	max_date: Date;
	min_date: Date;
	direction_delivery: boolean;

	discrepanza: {[key: string]: number} | null;

	constructor(
		public dialogService: DialogService,
		public ref: DynamicDialogRef,
		public config: DynamicDialogConfig<{
			src: CompoMovimentazione,
			direction_delivery: boolean
			materiali: ModelloDispositivoApiDescriptor[],
		}>,
		private messages: MessageService
	) {

		this.max_date = new Date();
		this.action_date = new Date();
		this.movref = config.data.src;
		this.min_date = this.movref.spedito != null ? dateFromYYYYMMDDsep(this.movref.spedito) : null;

		this.movtype = deserializeStringEnum(this.movref.tipo, TipoMovimentazione);
		this.discrepanza = null;
		this.direction_delivery = config.data.direction_delivery;

		this.verifyForm();

		// console.log(this.config.data);
	}

	verifyForm () {
		this.hasValidForm = this.action_date != null;
	}

	getDialogHeader (): string {

		const fase = this.direction_delivery ? "consegna" : "invio";
		// no allineamenti perché sono "automatici"
		if (this.movtype == TipoMovimentazione.IMPRESA_INSTALLAZIONE) {
			// TODO: USE SCHOOL DATA
			return `Registrazione ${fase} per la spedizione ${this.movref.id} di ${this.movref.mittente.ragioneSociale}`;
		} else if (this.movtype == TipoMovimentazione.IMPRESA_TIM) {
			return `Registrazione ${fase} per la spedizione ${this.movref.id} da ${this.movref.mittente.ragioneSociale} a TIM`;
		} else if (this.movtype == TipoMovimentazione.MAGAZZINO_MAGAZZINO) {
			return `Registrazione ${fase} per la spedizione ${this.movref.id} da ${this.movref.mittente.ragioneSociale} a ${this.movref.destinatario.ragioneSociale}`;
		} else if (this.movtype == TipoMovimentazione.TIM_IMPRESA) {
			return `Registrazione ${fase} per la spedizione ${this.movref.id} da TIM a ${this.movref.destinatario.ragioneSociale}`;
		} else {
			throw "tipo di movimentazione non previsto per questo form";
		}
	}

	openDiscrepanzaDialog () {
		const ref = this.dialogService.open(InconsistencyReportDialogComponent,
			{
				header: "Segnala discrepanza",
				modal: true,
				closable: false,
				width: "70vw",
				data: {
					src: this.config.data.src,
					materiali: this.config.data.materiali,
					values: this.discrepanza
				}
			}
		);

		ref.onClose.subscribe((diffs: {[key: string]: number})=> {
			if (diffs != null) {
				if (Object.values(diffs).every((item) => { return item == 0})) {
					this.discrepanza = null;
				} else {
					this.discrepanza = {...diffs};
				}
			}
		});


	}

	onActivityCompleted (confirm: boolean) {
		const datestr = dateAsYYYYMMDD(this.action_date, "-");
		this.ref.close(confirm ? {
			date: datestr,
			discrepanza: this.discrepanza != null ? Object.entries(this.discrepanza).map((item) => {
				return {id: item[0], qt: item[1]}
			}) : null
		} : null);
	}

}

